import { render, staticRenderFns } from "./RecentItems.vue?vue&type=template&id=1867becc"
import script from "./RecentItems.vue?vue&type=script&lang=ts"
export * from "./RecentItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports